import { BellOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';

import {
  useNotificationsBell,
  useNotificationsRealtime,
} from '@app/shared/components/NotificationsBell/hooks';
import { NotificationsListModal } from '@app/shared/components/NotificationsBell/ui/NotificationsListModal';

import type { FC } from 'react';

import '@app/shared/components/NotificationsBell/styles/NotificationsBell.scss';

export const NotificationsBell: FC = () => {
  const { unreadCount, isModalOpen, openModal, closeModal } =
    useNotificationsBell();

  useNotificationsRealtime();

  return (
    <>
      <Badge
        className="notifications-bell-badge"
        count={unreadCount}
        overflowCount={99}
        size="small"
        offset={[-10, 2]}
      >
        <Button
          type="text"
          shape="circle"
          size="small"
          className="notifications-bell-button"
          icon={<BellOutlined />}
          onClick={openModal}
          aria-label="Уведомления"
          data-testid="notifications-bell-button"
        />
      </Badge>
      <NotificationsListModal open={isModalOpen} onClose={closeModal} />
    </>
  );
};
